/**
 * ElectAI Assistant Component
 * Handles the floating assistant widget with iframe
 */

function initElectAIAssistant() {
    const assistant = document.getElementById('electaiAssistant');
    const toggleButton = document.getElementById('electaiAssistantToggle');
    const heroToggleButton = document.getElementById('heroElectAIToggle');
    const closeButton = document.getElementById('electaiAssistantClose');
    const frame = document.getElementById('electaiAssistantFrame');
    
    if (!assistant || !closeButton || !frame || (!toggleButton && !heroToggleButton)) {
        console.warn('ElectAI Assistant elements not found');
        return;
    }
    
    // Toggle assistant frame
    function openAssistant() {
        frame.classList.add('electai-assistant__frame--open');
        assistant.classList.add('electai-assistant--open');
        if (toggleButton) {
            toggleButton.setAttribute('aria-expanded', 'true');
        }
        // Prevent body scroll when assistant is open (optional)
        // document.body.style.overflow = 'hidden';
    }
    
    function closeAssistant() {
        frame.classList.remove('electai-assistant__frame--open');
        assistant.classList.remove('electai-assistant--open');
        if (toggleButton) {
            toggleButton.setAttribute('aria-expanded', 'false');
        }
        // Restore body scroll
        // document.body.style.overflow = '';
    }
    
    // Event listeners for toggle buttons
    if (toggleButton) {
        toggleButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openAssistant();
        });
    }
    
    // Hero button also opens the assistant
    if (heroToggleButton) {
        heroToggleButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openAssistant();
        });
    }
    
    closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeAssistant();
    });
    
    // Close when clicking outside the frame (optional)
    document.addEventListener('click', (e) => {
        if (frame.classList.contains('electai-assistant__frame--open')) {
            const isClickInside = frame.contains(e.target);
            const isClickOnToggle = toggleButton && toggleButton.contains(e.target);
            const isClickOnHeroToggle = heroToggleButton && heroToggleButton.contains(e.target);
            
            if (!isClickInside && !isClickOnToggle && !isClickOnHeroToggle) {
                closeAssistant();
            }
        }
    });
    
    // Prevent frame clicks from closing
    frame.addEventListener('click', (e) => {
        e.stopPropagation();
    });
}

// Expose to global for concatenated builds
window.initElectAIAssistant = initElectAIAssistant;

